import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Grid, Panel, Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import {change} from 'redux-form';
import LoginForm from './LoginForm';
import {FormErrors} from 'components/common';
import {login} from 'actions/account';
import {formatErrors} from 'actions/errors';

class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      errors: {},
    };
    this.setCredentials = this.setCredentials.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  setCredentials(role) {
    const {change} = this.props;
    change('LoginForm', 'email', `demo-${role}@kluwell.com`);
    change('LoginForm', 'password', 'demo');
  }

  handleFormSubmit(data) {
    const {login, formatErrors} = this.props;
    const {router} = this.context;
    return login(data)
      .then(() => router.history.push('/'))
      .catch((err) =>
        formatErrors(err).then((err) => {
          this.setState({
            errors: err,
          });
        }),
      );
  }

  render() {
    const {errors} = this.state;
    const {isTrial} = this.props;
    return (
      <div className="authentication login">
        <Grid className="content-box">
          <h1 className="kluwell-logo">
            <img alt="Kluwell" src="/images/kluwell-logo.svg" />
          </h1>
          <Panel>
            <FormErrors errors={errors} />
            <LoginForm onSubmit={this.handleFormSubmit} />
            <Row>
              <br />
              <Col xs={12}>
                <Link to="/account/forgot-password">
                  <Button>Forgot Password</Button>
                </Link>
              </Col>
            </Row>
          </Panel>
          {!isTrial ? (
            <div className="more-info">
              <Link to="/trial">
                <Button variant="contained" fullWidth>
                  Begin Trial
                </Button>
              </Link>
              <a target="_blank" href="https://kluwell.com/app-trial/">
                <Button variant="contained" fullWidth>
                  Request a Trial
                </Button>
              </a>
            </div>
          ) : (
            [
              <Panel key="demo-accounts" className="demo-accounts">
                <p>Login with a demo account to explore the functions available to different users:</p>
                <ul>
                  <li className="cursor-pointer hover-underline" onClick={() => this.setCredentials('reader')}>
                    <code>demo-reader@kluwell.com</code>
                  </li>
                  <li className="cursor-pointer hover-underline" onClick={() => this.setCredentials('coordinator')}>
                    <code>demo-coordinator@kluwell.com</code>
                  </li>
                  <li className="cursor-pointer hover-underline" onClick={() => this.setCredentials('teacher')}>
                    <code>demo-teacher@kluwell.com</code>
                  </li>
                </ul>
                <p>
                  The password for each account is <code>demo</code>
                  <br />
                  Hint:click an address to auto-fill its login!)
                </p>
                <p>The demo account resets hourly.</p>
              </Panel>,
              <div key="more-info" className="more-info">
                <a href="https://kluwell.com/app/">
                  <Button variant="contained" fullWidth>
                    More Info
                  </Button>
                </a>
                <a href="https://wepushbuttons.groovehq.com/groove_client/mailboxes/66279/filters/245419">
                  <Button variant="contained" fullWidth>
                    Support
                  </Button>
                </a>
              </div>,
            ]
          )}
        </Grid>
      </div>
    );
  }
}

Login.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  formatErrors: (...args) => dispatch(formatErrors(...args)),
  login: (...args) => dispatch(login(...args)),
  change: (...args) => dispatch(change(...args)),
});

export default connect(null, mapDispatchToProps)(Login);
